var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-text-content",staticStyle:{"height":"400px","overflow-y":"auto"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacyContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }